import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`

const ChildPhoto = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 8px;
  background-color: rgba(0,0,0,.2);;
`

const ChildInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 8px;
  flex: 1;
`

const ChildContext = styled.span`
  font-size: 12px;
  color: rgba(0,0,0,.5);
`
const ChildName = styled.h3`
  margin: 0;
`

const CheckContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Checkmark = styled.img`
  height: 20px;
`
const ChildButton = props => (
  <Container onClick={props.onClick} id={props.id}>
    <ChildPhoto src={props.profile_pictures ? props.profile_pictures['original'] : '/assets/BabyAvatar.svg'} />
    <ChildInfo>
      <ChildName>{props.name}</ChildName>
      <ChildContext>{props.context}</ChildContext>
    </ChildInfo>
    <CheckContainer>
      {props.active && <Checkmark src="/assets/blue_checkmark.svg" />}
    </CheckContainer>
  </Container>
)

export default ChildButton



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/Navbar/ChildButton.jsx